/* globals lg, theme */

export const quickAddToCart = (id) => {
  const addData = {
    id: id,
    quantity: 1,
  };

  return fetch(theme.routes.cartAdd, {
    method: 'POST',
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then(function (response) {
      return response.json();
    })
    .catch(function (err) {
      /* uh oh, we have error. */
      console.error(err);
    });
};

export function getQueryStringParameters() {
  const parameters = {};
  const query = document.location.search.slice(1);
  if (query !== undefined) {
    const parts = query.split('&');
    for (var i = 0; i < parts.length; i++) {
      const hash = parts[i].split('=');
      parameters[hash[0]] = hash[1];
    }
  }
  return parameters;
}

export function containsAllClasses(el, classNames) {
  return classNames.every((className) => el.classList.contains(className));
}

export function loadJson(url, callback) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.overrideMimeType('application/json');
    xhr.open('GET', url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        resolve(JSON.parse(xhr.responseText));
      }
    };
    xhr.send(null);
  });
}

/**
 * Insert 3rd party async script in DOM
 * @param {String} id script id
 * @param {String} url script url
 */
export function insertAsyncScript(id, url) {
  if (document.getElementById(id)) return;
  const fjs = document.getElementsByTagName('SCRIPT')[0];
  const js = document.createElement('SCRIPT');
  js.setAttribute('data-force', 'true');
  js.id = id;
  js.async = true;
  js.src = url;
  fjs.parentNode.insertBefore(js, fjs);
}

export const isHomepage = () => lg.template.type === 'index';

export const isPage = (name) => lg.template.type === 'page' && lg.template.name === name;

/**
 * Capitalize first letter of a string
 * @param {string} string
 */
export const capitalize = (string) => string[0].toUpperCase() + string.slice(1);

export const getRandomArrayValue = (array) => array[Math.floor(Math.random() * array.length)];

export function mapCollectionToCountries(collection) {
  const collectionByCountries = [];
  collection.forEach((tea) => {
    tea.countries.forEach((country) => {
      if (!collectionByCountries[country]) {
        collectionByCountries[country] = [];
      }
      collectionByCountries[country].push(tea);
    });
  });
  return collectionByCountries;
}

export function getCountryCollectionUrl(countrycode) {
  const country = `${lg.i18n.countries[countrycode]}`.toLowerCase();
  return `/collections/all/${country}`;
}
